const ZOOM_LEVELS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export function getPdfPreviewZoomStep(scale: number, direction: 'in' | 'out') {
  return direction === 'in'
    ? ZOOM_LEVELS.find((level) => level > scale)
    : ZOOM_LEVELS.findLast((level) => level < scale);
}
